import { Link, useParams } from 'react-router-dom';
import { ChevronRight, GraduationCap, IndianRupee } from 'lucide-react';
import { getModuleConfig, type ModuleKey } from '../../lib/moduleConfig';
import PaymentSummary from '../../components/PaymentSummary';

// Hardcoded classes 6-12 - NEVER dynamic
const FIXED_CLASSES = [
  { id: 1, name: 'Class 6', grade_number: 6 },
  { id: 2, name: 'Class 7', grade_number: 7 },
  { id: 3, name: 'Class 8', grade_number: 8 },
  { id: 4, name: 'Class 9', grade_number: 9 },
  { id: 5, name: 'Class 10', grade_number: 10 },
  { id: 6, name: 'Class 11', grade_number: 11 },
  { id: 7, name: 'Class 12', grade_number: 12 },
];

const classIdMap: Record<string, string> = {
  'Class 6': '1', 'Class 7': '2', 'Class 8': '3',
  'Class 9': '4', 'Class 10': '5', 'Class 11': '6', 'Class 12': '7',
};

export default function ModuleClassesPage() {
  const { module } = useParams();
  const config = getModuleConfig(module);
  const moduleKey = (module || 'students') as ModuleKey;
  const Icon = config.icon;

  return (
    <div className="space-y-4 pb-4">
      <div className={`rounded-2xl bg-gradient-to-br ${config.gradient} p-5 text-white shadow-xl overflow-hidden relative`}>
        <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-white/15" />
        <div className="relative flex items-start gap-3">
          <div className="h-12 w-12 rounded-2xl bg-white/18 flex items-center justify-center">
            <Icon className="h-6 w-6" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-white/75">Choose class</p>
            <h1 className="text-2xl font-black mt-1">{config.label}</h1>
            <p className="text-sm text-white/80 mt-1 max-w-md">{config.description}</p>
          </div>
        </div>
      </div>

      {/* Payment Overview - only for payments module */}
      {moduleKey === 'payments' && (
        <div className="rounded-2xl bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/20 p-4">
          <h2 className="text-sm font-bold text-amber-900 dark:text-amber-100 mb-3 flex items-center gap-2">
            <IndianRupee className="w-4 h-4" />
            Overall Payment Summary
          </h2>
          <PaymentSummary onClassClick={(className) => {
            const id = classIdMap[className];
            if (id) window.location.href = `/modules/payments/classes/${id}`;
          }} />
        </div>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {FIXED_CLASSES.map((cls) => (
          <Link
            key={cls.id}
            to={`/modules/${moduleKey}/classes/${cls.id}`}
            className="group rounded-2xl border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface p-4 min-h-[104px] shadow-sm active:scale-[0.98] transition-all hover:-translate-y-0.5 hover:shadow-lg"
          >
            <div className="flex items-center justify-between">
              <div className="h-10 w-10 rounded-xl bg-slate-100 dark:bg-white/10 flex items-center justify-center">
                <GraduationCap className="h-5 w-5 text-slate-800 dark:text-white" />
              </div>
              <ChevronRight className="h-5 w-5 text-light-text-muted group-hover:translate-x-0.5 transition-transform" />
            </div>
            <div className="mt-4">
              <p className="text-2xl font-black text-light-text dark:text-dark-text leading-none whitespace-nowrap">{cls.name}</p>
              <p className="text-xs text-light-text-muted mt-1">Open {config.label}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
